import { useEffect, useState } from 'react';
import baseService from '../services/base';

const TIPOS_DE_IMAGEM = ['image/png', 'image/jpeg', 'image/svg+xml'];

/**
 * A capa do pilar, buscada COM autenticação, como object URL local.
 * Porta de gs-form-survey-ui/src/hooks/useCapaDoPilar.ts: a rota /image
 * exige Bearer token, então precisa passar pelo axios central (baseService)
 * e não por um fetch cru. Revoga o object URL no cleanup para não vazar
 * blob a cada pilar renderizado.
 */
export function useCapaDoPilar(imgPillar) {
  const [imageURL, setImageURL] = useState('');

  useEffect(() => {
    if (!imgPillar || !imgPillar.startsWith('pillar/')) {
      setImageURL('');
      return;
    }

    let ativo = true;
    let urlLocal = null;

    const buscar = async () => {
      try {
        const resposta = await baseService.get(
          `/image/${imgPillar.replace('pillar/', 'pillar%2F')}`,
          { responseType: 'blob' }
        );

        const blob = resposta.data;
        if (!blob || !TIPOS_DE_IMAGEM.includes(blob.type)) return;

        const url = URL.createObjectURL(blob);

        if (!ativo) {
          URL.revokeObjectURL(url);
          return;
        }

        urlLocal = url;
        setImageURL(url);
      } catch {
        if (ativo) setImageURL('');
      }
    };

    buscar();

    return () => {
      ativo = false;
      if (urlLocal) URL.revokeObjectURL(urlLocal);
    };
  }, [imgPillar]);

  return imageURL;
}

export default useCapaDoPilar;
